<div class="position-relative wrapper" [ngClass]="{'min-w-10':minW}">
  <ng-select #select [items]="items" [ngModel]="model" [bindValue]="bindValue" [bindLabel]="bindLabel"
    [dropdownPosition]="dropdownPosition" [addTag]="addTag" [appendTo]="appendTo" [loading]="loading"
    [clearable]="clearable" [multiple]="multiple" [placeholder]="placeholder||'---'" [searchFn]="searchFn"
    [addTagText]="'add_item'|translate" (blur)="blur.emit($event)" (change)="change.emit($event)"
    (search)="search.emit($event)" (ngModelChange)="modelChange.emit($event)" [name]="name+'_select'"
    [disabled]="disabled" [ngClass]="[(required && isEmpty()) ? 'invalid':'', customClass]" [minTermLength]="1"
    [searchable]="searchable" [tabIndex]="tabIndex" [groupBy]="groupBy" [compareWith]="compareWith">
    <ng-template ng-label-tmp let-item="item" *ngIf="customLabel">
      <span class="px-1">{{customLabel(item)}}</span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" *ngIf="customOption">
      {{customOption(item)}}
    </ng-template>
    <ng-container *ngIf="showTranslateAppendix">
      <ng-template ng-label-tmp let-item="item">
        <span class="px-1">{{getItemWithAppendix(item)|translate}}</span>
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        {{getItemWithAppendix(item)|translate}}
      </ng-template>
    </ng-container>
  </ng-select>

  <input type="text" class="size-0 position-absolute" tabindex="-1" [required]="required && isEmpty()"
    [name]="name+'_required'">
</div>
